import dayjs from 'dayjs'

/**
 * Mock Sentry Issues Data - Inbound Workstream
 * Matches the actual API response structure
 */
export const mockSentryIssuesInbound = {
  success: true,
  issues: [
    {
      id: '6843177820',
      title: "TypeError: Cannot read property 'weight' of null",
      culprit: '/inbound/shipments/receive',
      status: 'unresolved',
      level: 'error',
      type: 'error',
      metadata: {
        title: 'TypeError',
        value: "Cannot read property 'weight' of null",
        type: 'TypeError',
        filename: 'ShipmentReceiver.tsx',
        function: 'validateWeight',
        in_app_frame_mix: 'mixed-frames',
      },
      numComments: 2,
      userCount: 7,
      count: 38,
      firstSeen: dayjs().subtract(3, 'weeks').toISOString(),
      lastSeen: dayjs().subtract(45, 'minutes').toISOString(),
      permalink: 'https://sentry.io/organizations/daylight/issues/6843177820/',
      shortId: 'INBOUND-1F1',
      project: {
        id: '4507465295659003',
        name: 'inbound',
        slug: 'inbound',
        platform: 'javascript-react',
      },
      assignedTo: {
        type: 'user',
        name: 'Mike Johnson',
        email: 'mike.johnson@daylight.com',
      },
      isBookmarked: false,
      isSubscribed: true,
      isUnhandled: true,
      hasSeen: true,
      annotations: [],
      logger: '',
      priority: 'high',
      filtered: {
        count: 38,
        userCount: 7,
        firstSeen: dayjs().subtract(3, 'weeks').toISOString(),
        lastSeen: dayjs().subtract(45, 'minutes').toISOString(),
      },
      lifetime: {
        count: 38,
        userCount: 7,
        firstSeen: dayjs().subtract(3, 'weeks').toISOString(),
        lastSeen: dayjs().subtract(45, 'minutes').toISOString(),
      },
      enrichedEnvironment: 'PROD',
    },
    {
      id: '6843177821',
      title: 'RangeError: Maximum call stack size exceeded',
      culprit: '/inbound/dock/scheduler',
      status: 'unresolved',
      level: 'error',
      type: 'error',
      metadata: {
        title: 'RangeError',
        value: 'Maximum call stack size exceeded',
        type: 'RangeError',
        filename: 'DockScheduler.tsx',
        function: 'recursiveSchedule',
        in_app_frame_mix: 'in-app-only',
      },
      numComments: 4,
      userCount: 3,
      count: 18,
      firstSeen: dayjs().subtract(10, 'days').toISOString(),
      lastSeen: dayjs().subtract(4, 'hours').toISOString(),
      permalink: 'https://sentry.io/organizations/daylight/issues/6843177821/',
      shortId: 'INBOUND-2G2',
      project: {
        id: '4507465295659003',
        name: 'inbound',
        slug: 'inbound',
        platform: 'javascript-react',
      },
      assignedTo: null,
      isBookmarked: true,
      isSubscribed: false,
      isUnhandled: true,
      hasSeen: false,
      annotations: [],
      logger: '',
      priority: 'medium',
      filtered: {
        count: 18,
        userCount: 3,
        firstSeen: dayjs().subtract(10, 'days').toISOString(),
        lastSeen: dayjs().subtract(4, 'hours').toISOString(),
      },
      lifetime: {
        count: 18,
        userCount: 3,
        firstSeen: dayjs().subtract(10, 'days').toISOString(),
        lastSeen: dayjs().subtract(4, 'hours').toISOString(),
      },
      enrichedEnvironment: 'QA',
    },
    {
      id: '6843177822',
      title: 'ChunkLoadError: Loading chunk 2 failed',
      culprit: '/inbound/service-centers/list',
      status: 'unresolved',
      level: 'warning',
      type: 'error',
      metadata: {
        title: 'ChunkLoadError',
        value: 'Loading chunk 2 failed',
        type: 'ChunkLoadError',
        filename: 'webpack',
        function: 'loadChunk',
        in_app_frame_mix: 'system-only',
      },
      numComments: 0,
      userCount: 9,
      count: 54,
      firstSeen: dayjs().subtract(1, 'month').toISOString(),
      lastSeen: dayjs().subtract(15, 'minutes').toISOString(),
      permalink: 'https://sentry.io/organizations/daylight/issues/6843177822/',
      shortId: 'INBOUND-3H3',
      project: {
        id: '4507465295659003',
        name: 'inbound',
        slug: 'inbound',
        platform: 'javascript-react',
      },
      assignedTo: null,
      isBookmarked: false,
      isSubscribed: false,
      isUnhandled: false,
      hasSeen: true,
      annotations: [],
      logger: '',
      priority: 'low',
      filtered: {
        count: 54,
        userCount: 9,
        firstSeen: dayjs().subtract(1, 'month').toISOString(),
        lastSeen: dayjs().subtract(15, 'minutes').toISOString(),
      },
      lifetime: {
        count: 54,
        userCount: 9,
        firstSeen: dayjs().subtract(1, 'month').toISOString(),
        lastSeen: dayjs().subtract(15, 'minutes').toISOString(),
      },
      enrichedEnvironment: 'PROD',
    },
  ],
  pagination: {
    nextCursor: null,
    hasMore: false,
    recordCount: 3,
  },
  'x-hits': 3,
  recordCount: 3,
}

export const mockPriorityCountsInbound = {
  success: true,
  'priority-counts': {
    high: 1,
    medium: 1,
    low: 1,
  },
  'x-hits': 3,
}
